import { useNavigate } from 'react-router-dom';
import { Heart, Clock, Home } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';
import { Card } from '@/shared/components/ui/card';

export function ConciergeHandoff() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background px-4 py-8">
      <div className="container mx-auto flex min-h-[calc(100vh-10rem)] items-center justify-center">
        <Card className="w-full max-w-2xl p-10">
          <div className="mb-6 text-center">
            <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-blue-100">
              <Heart className="text-[#026857]" size={32} />
            </div>
            <h1 className="mb-4 text-3xl font-semibold text-gray-900">We'd Like to Help Personally</h1>
          </div>

          <div className="mb-8 space-y-4 leading-relaxed text-gray-700">
            <p>
              Your situation requires the thoughtful attention of one of our Care Concierge specialists.
              They have deep expertise in navigating complex care needs and will work with you one-on-one
              to create the right plan.
            </p>

            <p>
              <strong className="text-gray-900">Everything you've shared has been saved.</strong> You won't
              need to repeat yourself. A member of our team will reach out within one business day to
              continue your care planning journey.
            </p>

            <Card className="mt-6 border-blue-200 bg-blue-50 p-4">
              <div className="flex items-start gap-3">
                <Clock className="mt-1 flex-shrink-0 text-[#026857]" size={20} />
                <div>
                  <p className="mb-1 font-medium text-gray-900">Expected Response Time</p>
                  <p className="text-sm text-gray-700">
                    A Care Concierge will contact you by email or phone within 24 hours on business days.
                  </p>
                </div>
              </div>
            </Card>
          </div>

          <div className="space-y-3">
            <Button
              onClick={() => navigate('/dashboard')}
              className="w-full bg-[#026857] py-6 text-lg hover:bg-[#025247]"
              size="lg"
            >
              <Home size={20} className="mr-2" />
              Return to Dashboard
            </Button>

            <Button
              variant="outline"
              className="w-full border-[#026857] py-6 text-[#026857] hover:bg-[#026857] hover:text-white"
              onClick={() => navigate('/resources')}
              size="lg"
            >
              Browse Resources
            </Button>
          </div>

          <p className="mt-6 text-center text-sm text-gray-500">
            Need immediate assistance? Call our 24/7 helpline:{' '}
            <span className="font-medium text-[#026857]">(800) 555-CARE</span>
          </p>
        </Card>
      </div>
    </div>
  );
}